import React from 'react'
import LuxuryPlusLabel from './LuxuryPlusLabel'
import styled from 'styled-components'
import { rem } from 'polished'
import { isLuxuryPlusEnabled, isActiveLuxuryPlusMember } from 'loyalty/selectors/featureToggle'
import { connect } from 'react-redux'
import Breakpoint from 'components/Common/Breakpoint'

interface Props {
  children: React.ReactNode;
  isLuxuryPlusEnabled: boolean,
  isActiveLuxuryPlusMember: boolean,
}

const Container = styled.div`
  --gutter: ${rem(16)};
  max-width: ${rem(328)};
  display: grid;
  grid-template-columns: [border-start] var(--gutter) [content-start] 1fr [content-end] var(--gutter) [border-end];
  grid-template-rows: [label-start] auto [border-start] auto [label-end] 0px [content-start] 1fr [content-end] var(--gutter) [border-end];
`

const LabelContainer = styled.div`
  grid-column: content;
  grid-row: label;
`

const Border = styled.div`
  grid-column: border;
  grid-row: border;
  border: 1px solid ${props => props.theme.palette.product.loyalty};
`

const Content = styled.div`
  grid-column: content;
  grid-row: content;
`

function LuxuryPlusInclusions(props: Props) {
  const { children, isLuxuryPlusEnabled, isActiveLuxuryPlusMember } = props

  if (!isLuxuryPlusEnabled) return null

  if (!isActiveLuxuryPlusMember) {
    return (
      <div data-testid="luxury-plus-inclusions-non-member">
        <Breakpoint not="tablet"><LuxuryPlusLabel type="extra-inclusions-with" showInfoIcon /></Breakpoint>
        <Breakpoint only="tablet"><LuxuryPlusLabel showInfoIcon /></Breakpoint>
      </div>
    )
  }

  return (
    <Container data-testid="luxury-plus-inclusions-member">
      <Border aria-hidden="true" />
      <LabelContainer>
        <Breakpoint not="tablet"><LuxuryPlusLabel type="extra-inclusions-with" /></Breakpoint>
        <Breakpoint only="tablet"><LuxuryPlusLabel /></Breakpoint>
      </LabelContainer>
      <Content>{children}</Content>
    </Container>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isActiveLuxuryPlusMember: isActiveLuxuryPlusMember(state),
    isLuxuryPlusEnabled: isLuxuryPlusEnabled(state),
  }
}

export default connect(mapStateToProps)(LuxuryPlusInclusions)
